module.exports = __webpack_public_path__ + "img/example.46de1b6f.png";